import { render } from "./Preview.vue?vue&type=template&id=6ed8228f"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
script.render = render

export default script